export default __webpack_public_path__ + "static/media/productivity.6ac6013a.svg";